import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-project-search',
  templateUrl: './project-search.component.html',
  styleUrls: ['./project-search.component.scss']
})
export class ProjectSearchComponent implements OnInit, OnDestroy {
  @Output() searchData = new EventEmitter<any>();

  searchStr: string = '';
  activeCol: { title: string; value: string }[] = [];
  searchOptions = [
    { title: 'Project Name', value: 'PROJECT_NAME' }
  ];
  private searchSubscription!: Subscription;
  private searchSubject = new Subject<string>()
  constructor() { }
  ngOnInit(): void {
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(() => {
      this.emitSearchData()
    })
  }
  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe()
  }
  changeIndex(event: any) {
    this.activeCol = this.searchOptions.filter(
      (option) => option.value === event
    );
  }
  OnInputChanges() {
    this.searchSubject.next(this.searchStr)
  }
  removeClick() {
    this.searchStr = '';
    this.emitSearchData();
  }

  search() {
    this.emitSearchData();
  }

  private emitSearchData() {
    this.searchData.emit({
      searchBy: this.activeCol[0]?.value || 'PROJECT_NAME',
      searchText: this.searchStr
    });
  }
}
